/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AgentConnectionBlockIDForm = {
  /**
   * Connection block identifier
   */
  blockId: string;
};

/** @internal */
export type AgentConnectionBlockIDForm$Outbound = {
  block_id: string;
};

/** @internal */
export const AgentConnectionBlockIDForm$outboundSchema: z.ZodMiniType<
  AgentConnectionBlockIDForm$Outbound,
  AgentConnectionBlockIDForm
> = z.pipe(
  z.object({
    blockId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      blockId: "block_id",
    });
  }),
);

export function agentConnectionBlockIDFormToJSON(
  agentConnectionBlockIDForm: AgentConnectionBlockIDForm,
): string {
  return JSON.stringify(
    AgentConnectionBlockIDForm$outboundSchema.parse(agentConnectionBlockIDForm),
  );
}
